<template>
    <div class="insight-data-landing-page">
      <div class="loading-spinner-outer" v-if="sending">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Sending, please wait
          </div>
        </div>
      </div>
        <div class="landing-page-introduction-box">
            <div class="title">
                <div>
                    Market Research in partnership with Insight Data
                </div>
                <div class="logo">
                    <img src="/images/insight-data-logo-small.png">
                </div>
            </div>
            <div class="box-1">
                <h1>Get an exclusive 10% discount on market research over £500.</h1>
              <p>
                Market research and business intelligence helps company to leaders make informed business decisions, reducing risk and costly mistakes. It can also help businesses understand the market, competitors, and customers better, improving their sales and marketing proposition while helping to better deploy resources.
              </p>
              <p>
                Insight Data will work with you to understand your requirements and agree on the process and most suitable methods of collecting the data.
              </p>
              <p>
                The finished results can be provided in several formats, and our experienced management team will produce an executive summary or opinion on the work.
              </p>
            </div>
            <div class="overlapping-image">
                <img src="/images/offers-and-promotions-market-research-header.png">
            </div>
            <div class="box-2">
                <p>
                  <strong>
                    Research services include:
                  </strong>
                  <br>
                  Dedicated market research<br>
                  Industry/product research<br>
                  Perception analysis/benchmarking<br>
                  Competitor research<br>
                  Customer surveys
                </p>
                <p>
                    <a class="btn-primary-outline _lg" @click.prevent="enquiry_box_open = true">
                        Make Enquiry
                    </a>
                </p>
            </div>
        </div>
        <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="enquiry_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Market Research Enquiry</h1>
                </div>
                <div class="modal-content">
                    <div class="form-group">
                        Please enter details of your enquiry below.
                    </div>
                    <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiry()">
                        Send
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'logged_in_user',
    ],
    data() {
        return {
            'enquiry_box_open': false,
            'enquiry_message': 'I would like some more information on Market Research',
          sending: false,
        }
    },
    methods: {
        sendEnquiry() {
          this.enquiry_box_open = false;
          this.sending = true;
            axios.post('/enquiry/send', {
                'enquiry_type_id': 31,
                'message': this.enquiry_message,
            }).then((response) => {

              gtag('event', 'enquiry_made', {
                'event_category': 'enquiries',
                'event_label': 'Market Research enquiry',
                'value': 'Market Research enquiry',
              });

              this.sending = false;
                Swal.fire({
                    title: 'Enquiry Sent',
                    icon: 'success',
                    text: 'Your enquiry has been sent, you will be sent a notification when you receive a reply.'
                });
            });
        },
      partnerLinkClicked() {
        axios.post('/activity-logs/createActivityLogFromRequest', {
          'activity_log_category_id': 3,
          'description': `Partner Link Clicked - Insight Data Market Research`,
        });
        gtag('event', 'partner_link_clicked', {
          'event_category': 'link',
          'event_label': 'Insight Data Market Research partner link clicked',
          'value': 'Insight Data Market Research partner link clicked',
        });
      },
    },
};
</script>
